<div class="bootstrap-wrapper">
    <div *ngIf="isGenerating">
        <mc-load-message messaeg="Fetching Data"></mc-load-message>
    </div>
    <div *ngIf="error" class="alert alert-danger container">
        {{ errorMessage }}
    </div>
    <div *ngIf="!error" id="onemap-report">
        <div class="reportSection" *ngIf="projectStatus">
            <div class="reportSectionHeader">
                Project Status Report
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-4">
                        <label>Project:&nbsp;</label>{{ projectStatus.projectTitle }}
                    </div>
                    <div class="col-xs-4">
                        <label>Date of Report:&nbsp;</label>{{ todaysDate }}
                    </div>
                    <div class="col-xs-4">
                        <label>Project ID:&nbsp;</label>{{ projectStatus.projectId }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Basic Information Section -->
        <div class="reportSection" *ngIf="projectStatus">
            <div class="reportSectionHeader">
                Basic Information
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-3">
                        <label>State Route:&nbsp;</label>{{ projectStatus.stRtNo }}
                    </div>
                    <div class="col-xs-3">
                        <label>TR:&nbsp;</label>{{ projectStatus.traf_rt_nm }}
                    </div>
                    <div class="col-xs-3">
                        <label>County:&nbsp;</label>{{ projectStatus.countyName }}
                    </div>
                    <div class="col-xs-3">
                        <label>Improvement Type:&nbsp;</label>{{ projectStatus.shortDesc }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-3">
                        <label>Length:&nbsp;</label>{{ projectStatus.totalLength }}
                    </div>
                    <div class="col-xs-3">
                        <label>Project Class:&nbsp;</label>{{ projectStatus.className }}
                    </div>
                    <div class="col-xs-3">
                        <label>Let Date:&nbsp;</label>
                        <span *ngIf="projectStatus.letDate">{{ projectStatus.letDate.substring(4,6) }}/{{ projectStatus.letDate.substring(6) }}/{{ projectStatus.letDate.substring(0,4) }}</span>
                    </div>
                    <div class="col-xs-3">
                        <label>Physical Work Complete:&nbsp;</label>
                        <span *ngIf="projectStatus.physicalDate">{{ projectStatus.physicalDate.substring(4,6) }}/{{ projectStatus.physicalDate.substring(6) }}/{{ projectStatus.physicalDate.substring(0,4) }}&nbsp;({{ projectStatus.physicallyReady }})</span>

                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-3">
                        <label>Open To Traffic:&nbsp;</label>
                        <span *ngIf="projectStatus.openDate">
                            {{ projectStatus.openDate.substring(4,6) }}/{{ projectStatus.openDate.substring(6) }}/{{ projectStatus.openDate.substring(0,4) }}&nbsp;
                            ({{ projectStatus.openFlag }})
                        </span>
                    </div>
                    <div class="col-xs-3">
                        <label>Capital Budget Year:&nbsp;</label>{{ projectStatus.capitalBudgetYear }}
                    </div>
                    <div class="col-xs-3">
                        <label>Is Decade of Investment:&nbsp;</label>{{ projectStatus.doiFlag }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Title/Location Section -->
        <div class="reportSection" *ngIf="projectStatus">
            <div class="reportSectionHeader">
                Title/Location
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <label>Title:&nbsp;</label>{{ projectStatus.projectTitle }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <label>Location Description:&nbsp;</label>{{ projectStatus.location }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Project Map -->
        <div class="reportSection">
            <div class="reportSectionHeader">
                Project Map
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="map" style="width:700px;height:300px;position:relative;">
                            <mc-map #mcMap></mc-map>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Cost Data Section -->
        <div class="reportSectionHeader">
            Cost Data ($1,000's)
        </div>
        <div class="costTableSection" *ngIf="reportData && reportData.costData">
            <table class="costTable table" aria-label="Cost Data">
                <thead>
                    <tr>
                        <th rowspan="2" scope="colgroup">Phase</th>
                        <th rowspan="2" scope="colgroup">Status</th>
                        <th rowspan="2" scope="colgroup">Past</th>
                        <th colspan="4" scope="colgroup">TIP {{ tipYears[0] }}</th>
                        <th colspan="4" scope="colgroup">TIP {{ tipYears[1] }}</th>
                        <th colspan="4" scope="colgroup">TIP {{ tipYears[2] }}</th>
                        <th colspan="4" scope="colgroup">TIP {{ tipYears[3] }}</th>
                    </tr>
                    <tr>
                        <th scope="col">Total</th>
                        <th scope="col">Fed</th>
                        <th scope="col">State</th>
                        <th scope="col">Local</th>
                        <th scope="col">Total</th>
                        <th scope="col">Fed</th>
                        <th scope="col">State</th>
                        <th scope="col">Local</th>
                        <th scope="col">Total</th>
                        <th scope="col">Fed</th>
                        <th scope="col">State</th>
                        <th scope="col">Local</th>
                        <th scope="col">Total</th>
                        <th scope="col">Fed</th>
                        <th scope="col">State</th>
                        <th scope="col">Local</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of reportData.costData">
                        <td>{{ row.phaseType }}</td>
                        <td>{{ row.phaseStatus }}</td>
                        <td>$&nbsp;{{ row.past }}</td>
                        <td>$&nbsp;{{ row.firstTotal }}</td>
                        <td>$&nbsp;{{ row.firstFed }}</td>
                        <td>$&nbsp;{{ row.firstState }}</td>
                        <td>$&nbsp;{{ row.firstLocal }}</td>
                        <td>$&nbsp;{{ row.secondTotal }}</td>
                        <td>$&nbsp;{{ row.secondFed }}</td>
                        <td>$&nbsp;{{ row.secondState }}</td>
                        <td>$&nbsp;{{ row.secondLocal }}</td>
                        <td>$&nbsp;{{ row.thirdTotal }}</td>
                        <td>$&nbsp;{{ row.thirdFed }}</td>
                        <td>$&nbsp;{{ row.thirdState }}</td>
                        <td>$&nbsp;{{ row.thirdLocal }}</td>
                        <td>$&nbsp;{{ row.fourthTotal }}</td>
                        <td>$&nbsp;{{ row.fourthFed }}</td>
                        <td>$&nbsp;{{ row.fourthState }}</td>
                        <td>$&nbsp;{{ row.fourthLocal }}</td>
                    </tr>
                    <tr class="costFooter">
                        <td>&nbsp;</td>
                        <td>Totals</td>
                        <td>$&nbsp;{{ totals.pastTotal }}</td>
                        <td>$&nbsp;{{ totals.firstTotalTotal }}</td>
                        <td>$&nbsp;{{ totals.firstFedTotal }}</td>
                        <td>$&nbsp;{{ totals.firstStateTotal }}</td>
                        <td>$&nbsp;{{ totals.firstLocalTotal }}</td>
                        <td>$&nbsp;{{ totals.secondTotalTotal }}</td>
                        <td>$&nbsp;{{ totals.secondFedTotal }}</td>
                        <td>$&nbsp;{{ totals.secondStateTotal }}</td>
                        <td>$&nbsp;{{ totals.secondLocalTotal }}</td>
                        <td>$&nbsp;{{ totals.thirdTotalTotal }}</td>
                        <td>$&nbsp;{{ totals.thirdFedTotal }}</td>
                        <td>$&nbsp;{{ totals.thirdStateTotal }}</td>
                        <td>$&nbsp;{{ totals.thirdLocalTotal }}</td>
                        <td>$&nbsp;{{ totals.fourthTotalTotal }}</td>
                        <td>$&nbsp;{{ totals.fourthFedTotal }}</td>
                        <td>$&nbsp;{{ totals.fourthStateTotal }}</td>
                        <td>$&nbsp;{{ totals.fourthLocalTotal }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
